import * as actionTypes from "../ActionTypes";
import { apiDelete, apiGet, apiPost, apiPut } from "../axios";
import { generatePopup } from "../../utility/popup";

export const LoginAPI = (payload, dispatch) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.LOGIN_INIT,
    });

    try {
      const response = await apiPost("login", payload, null);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.LOGIN_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.LOGIN_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.LOGIN_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.LOGIN_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.LOGIN_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const getUserData = async (dispatch) => {
  const token = localStorage.getItem("token");
  try {
    const response = await apiGet("auth", token);
    if (response.status === 200) {
      dispatch({
        type: actionTypes.GET_USER_DATA,
        payload: response.data,
      });
      return response.data;
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const GetUsersData = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_USERS_DATA_INIT,
    });

    try {
      const response = await apiGet(
        `getstore?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search}`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_USERS_DATA_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_USERS_DATA_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.GET_USERS_DATA_FAIL,
          payload: error?.data?.message,
        });
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_USERS_DATA_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const AddStore = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_STORE_INIT,
    });

    try {
      const response = await apiPost("registration", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_STORE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_STORE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 400) {
        dispatch({
          type: actionTypes.ADD_STORE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.ADD_STORE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const DeleteStore = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_STORE_INIT,
    });

    try {
      const response = await apiDelete(`auth/${payload}`, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.DELETE_STORE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.DELETE_STORE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.DELETE_STORE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.DELETE_STORE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdateStore = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_USER_INIT,
    });

    try {
      const response = await apiPut(`auth/${payload.id}`, payload.data, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_USER_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_USER_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_USER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.UPDATE_USER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_USER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      throw error;
    }
  };
};

export const ForgotPasswordAPI = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.FORGOT_PASSWORD_INIT,
    });

    try {
      const response = await apiPost("forgot-password", payload, null);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.FORGOT_PASSWORD_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.FORGOT_PASSWORD_FAIL,
          payload: response?.data?.message,
        });
        generatePopup("error", response?.data?.message);
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FORGOT_PASSWORD_FAIL,
        payload: error?.data?.message,
      });
      generatePopup("error", error?.data?.message || "Something went wrong");
      return error;
    }
  };
};

export const ResetPasswordAPI = (payload) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PASSWORD_INIT,
    });

    try {
      const response = await apiPost("reset-password", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.RESET_PASSWORD_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.RESET_PASSWORD_FAIL,
          payload: response?.data?.message,
        });
        generatePopup("error", response?.data?.message);
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: actionTypes.RESET_PASSWORD_FAIL,
        payload: error?.data?.message,
      });
      generatePopup("error", error?.data?.message || "Something went wrong");
      return error;
    }
  };
};

